import Vue from 'vue'

Vue.directive('wave', {
    
    inserted: function (el, binding) {
        let effect = typeof binding.value !== undefined ? 'waves-' + binding.value : '';
        el.classList.add('waves-effect', effect);
    },
    bind(el) {
        el.addEventListener('click', function(){
            el.classList.add('animate-waves');
            setTimeout(() => {
                el.classList.add('out');
            }, 500);
            setTimeout(() => {
                el.classList.remove('out', 'animate-waves');
            }, 1500);
        });
    },
  })